<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm1"></a></p><a id="fm1">
<div class="fmhT"><b><i>How to Use This Book</i></b></div>
<div class="fmtx1">Look no further: everything you need to write clear and efficient e-mails is between the covers of this book!</div>
<div class="leftAligned"><img alt="003" class="imgepub" src="bano_9781601638632_oeb_003_r1.jpg"/></div>
<div class="fmtx1"><b>Models</b> <i>show you how it’s done.</i></div>
<div class="leftAligned"><img alt="004" class="imgepub" src="bano_9781601638632_oeb_004_r1.jpg"/></div>
<div class="fmtx1"><b>Maps</b> <i>provide flexible document outlines for every e-mail task.</i></div>
<div class="leftAligned"><img alt="005" class="imgepub" src="bano_9781601638632_oeb_005_r1.jpg"/></div>
<div class="fmtx1"><b>Tools</b> <i>explains the why and how of e-mail English.</i></div>
<div class="leftAligned"><img alt="006" class="imgepub" src="bano_9781601638632_oeb_006_r1.jpg"/></div>
<div class="fmtx1"><b>Netiquette</b> <i>describes e-mail trends.</i></div>
<div class="leftAligned"><img alt="007" class="imgepub" src="bano_9781601638632_oeb_007_r1.jpg"/></div>
<div class="fmtx1"><b>Options</b> <i>illustrates how to swap words and phrases.</i></div>
<div class="leftAligned"><img alt="008" class="imgepub" src="bano_9781601638632_oeb_008_r1.jpg"/></div>
<div class="fmtx1"><b>Inbox</b> <i>helps control the impression your e-mail makes.</i></div>
<div class="leftAligned"><img alt="009" class="imgepub" src="bano_9781601638632_oeb_009_r1.jpg"/></div>
<div class="fmtx1"><b>Edit</b> <i>shows you how to revise your e-mail.</i></div>
<div class="leftAligned"><img alt="010" class="imgepub" src="bano_9781601638632_oeb_010_r1.jpg"/></div>
<div class="fmtx1"><b>Advice</b> <i>supplies practical guidance on essential writing issues.</i></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bano_9781601638632_oeb_fm1_r1.vue?86c8b702